"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBox = void 0;
var _testidGenerator = require("@ori/testid-generator");
var _constantsGenerated = require("../constants-generated");
var _context = require("../context");
var _logger = require("../logger");
var _ErrorBoundary = require("./ErrorBoundary");
var _InnerProductBox = require("./InnerProductBox");
var _Translations = require("./Translations");
var _jsxRuntime = require("react/jsx-runtime");
const childLogger = _logger.mainLogger.createChild('ProductBox');
const ProductBox = ({
  translations,
  withTranslationsProvider,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
  logger: childLogger,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
    team: _testidGenerator.Team.Presentation,
    project: _constantsGenerated.APP_NAME,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Translations.Translations, {
      translations: translations,
      withTranslationsProvider: withTranslationsProvider,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_context.ProductProvider, {
        value: props,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerProductBox.InnerProductBox, {})
      })
    })
  })
});
exports.ProductBox = ProductBox;
